import { useContext } from "react";
import { themeContext } from "../../context/theme";
import { svgThemes } from "../../utilities/utilities";
export const CardsFlying = () => {
      const { theme } = useContext(themeContext);

      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  style={{
                        display: "block",
                        zIndex: 1,
                        position: "absolute",
                        pointerEvents: "none",
                  }}
                  width={"100vw"}
                  height={"100svh"}
                  preserveAspectRatio="xMidYMid"
                  viewBox="0 0 1536 750"
            >
                  <g transform="translate(768,375) scale(1,1) translate(-768,-375)">
                        <style type="text/css">
                              {
                                    "\n  @keyframes ld-fall {\n    0%    { transform: translate(0,0px) rotate3d(1,1,1,0deg); }\n    16.6% { transform: translate(0,127px) rotate3d(1,1,1,180deg); }\n    33.3% { transform: translate(0,254px) rotate3d(1,1,1,360deg); }\n    50.0% { transform: translate(0,381px) rotate3d(1,1,1,540deg); }\n    66.6% { transform: translate(0,508px) rotate3d(1,1,1,720deg); }\n    83.3% { transform: translate(0,635px) rotate3d(1,1,1,900deg); }\n    100%  { transform: translate(0,762px) rotate3d(1,1,1,1080deg) ; }\n  }\n  .ld.ld-fall {\n    animation: ld-fall 10s linear infinite;\n  }\n  .ld.ld-fall2 {\n    animation: ld-fall 10s linear infinite;\n    animation-fill-mode: forwards;\n  }\n"
                              }
                        </style>
                        <g transform="translate(0 326.53663813591106)">
                              <g transform="translate(252.12227801608503 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-1.8048847657627323s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-5.235129825022388}
                                                y={-4.026585017063388}
                                                width={10.470259650044776}
                                                height={8.053170034126776}
                                                style={{
                                                      transform:
                                                            "scale(3.1297517360469627)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1258.3448244045794 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-1.5966347603718685s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-5.743152209341826}
                                                y={-4.14001727880739}
                                                width={11.486304418683652}
                                                height={8.28003455761478}
                                                style={{
                                                      transform:
                                                            "scale(1.966943666897683)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(838.364515292295 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-0.5755094982732336s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-3.92036839636315}
                                                y={-3.253722243825411}
                                                width={7.8407367927263}
                                                height={6.507444487650822}
                                                style={{
                                                      transform:
                                                            "scale(1.903626062460912)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1015.105708187234 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-0.7858345683472883s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-3.00806361499066}
                                                y={-4.415393764172474}
                                                width={6.01612722998132}
                                                height={8.830787528344947}
                                                style={{
                                                      transform:
                                                            "scale(2.2112911078009283)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1060.45111566171 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-3.0735867081755064s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-4.2424142475035485}
                                                y={-3.8647325906668284}
                                                width={8.484828495007097}
                                                height={7.729465181333657}
                                                style={{
                                                      transform:
                                                            "scale(3.4160492034266587)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1373.0199622557418 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-0.532368018314151s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-5.317705279152215}
                                                y={-4.695351610513324}
                                                width={10.63541055830443}
                                                height={9.390703221026648}
                                                style={{
                                                      transform:
                                                            "scale(1.6016231406732697)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1472.0101143125955 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-0.5399583963147014s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-5.643852761068592}
                                                y={-3.6685635490735997}
                                                width={11.287705522137184}
                                                height={7.337127098147199}
                                                style={{
                                                      transform:
                                                            "scale(2.5502843095803978)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1425.0652944873948 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-2.337849567994355s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-4.24630905925182}
                                                y={-5.7682884054520995}
                                                width={8.49261811850364}
                                                height={11.536576810904199}
                                                style={{
                                                      transform:
                                                            "scale(2.820631309798371)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(376.1028868134674 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-0.6321681512536546s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-4.300837667326902}
                                                y={-5.136110152907795}
                                                width={8.601675334653804}
                                                height={10.27222030581559}
                                                style={{
                                                      transform:
                                                            "scale(2.280587131750873)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1434.2938926926429 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-0.2428908212335772s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-3.454418954350106}
                                                y={-5.483404792092944}
                                                width={6.908837908700212}
                                                height={10.966809584185889}
                                                style={{
                                                      transform:
                                                            "scale(2.517065874313353)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(705.5726343039071 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-0.38706294322669343s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-4.665399952457015}
                                                y={-3.1946403688573155}
                                                width={9.33079990491403}
                                                height={6.389280737714631}
                                                style={{
                                                      transform:
                                                            "scale(2.2088639179512275)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(829.31785731886 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-0.9478907555685998s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-3.8206512138508923}
                                                y={-5.987615775511404}
                                                width={7.641302427701785}
                                                height={11.975231551022809}
                                                style={{
                                                      transform:
                                                            "scale(1.6131896288523453)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(824.1357551944989 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-1.238286012810513s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-4.1249450838428965}
                                                y={-4.095214800651716}
                                                width={8.249890167685793}
                                                height={8.190429601303432}
                                                style={{
                                                      transform:
                                                            "scale(1.922637988415215)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(738.1472922363736 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-3.3586830861603127s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-4.618067505077739}
                                                y={-5.689251093797545}
                                                width={9.236135010155477}
                                                height={11.37850218759509}
                                                style={{
                                                      transform:
                                                            "scale(2.6814541745169866)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(671.0494979538338 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-2.4443364994173784s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-5.579422461655465}
                                                y={-4.623248299549779}
                                                width={11.15884492331093}
                                                height={9.246496599099558}
                                                style={{
                                                      transform:
                                                            "scale(1.9099722829483055)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(34.68714404880325 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-1.165443733720314s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-3.8923959257898773}
                                                y={-5.957351342410082}
                                                width={7.7847918515797545}
                                                height={11.914702684820163}
                                                style={{
                                                      transform:
                                                            "scale(2.5700231125088155)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1210.1792984468862 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-0.09990602201506249s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-5.975072580789338}
                                                y={-5.857028882435017}
                                                width={11.950145161578677}
                                                height={11.714057764870034}
                                                style={{
                                                      transform:
                                                            "scale(2.9838935620062172)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(74.2272980749924 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-0.6238835618869936s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-4.170140999141763}
                                                y={-5.555002466097458}
                                                width={8.340281998283526}
                                                height={11.110004932194917}
                                                style={{
                                                      transform:
                                                            "scale(2.3484401304924183)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(24.450260667057364 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-1.0980882211384566s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-4.765488936738785}
                                                y={-3.712392812355025}
                                                width={9.53097787347757}
                                                height={7.42478562471005}
                                                style={{
                                                      transform:
                                                            "scale(2.4584834135676554)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1048.7710148638516 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-0.7767305253632597s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-3.1908039548001046}
                                                y={-3.1138407167145714}
                                                width={6.381607909600209}
                                                height={6.227681433429143}
                                                style={{
                                                      transform:
                                                            "scale(2.6031941369136247)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1420.8607191709311 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-0.22957772163329349s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-5.5045823033226915}
                                                y={-5.709917617429362}
                                                width={11.009164606645383}
                                                height={11.419835234858724}
                                                style={{
                                                      transform:
                                                            "scale(3.3402876491052225)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(816.1786468437467 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-2.190024442414451s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-3.5472473805333338}
                                                y={-3.4316080245859735}
                                                width={7.0944947610666675}
                                                height={6.863216049171947}
                                                style={{
                                                      transform:
                                                            "scale(1.7898834193936364)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1220.2570452900377 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-0.6588188521807083s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-3.5860250352656102}
                                                y={-5.031441210145333}
                                                width={7.1720500705312205}
                                                height={10.062882420290666}
                                                style={{
                                                      transform:
                                                            "scale(2.8126667061490416)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1020.1962290747173 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-3.839379413881523s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-4.603432080026506}
                                                y={-3.218349405299614}
                                                width={9.206864160053012}
                                                height={6.436698810599228}
                                                style={{
                                                      transform:
                                                            "scale(2.0148911136997034)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(787.9682766179483 0)">
                                    <g
                                          className="ld ld-fall2"
                                          style={{
                                                animationDelay:
                                                      "-1.548292379036611s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-4.567359603265739}
                                                y={-4.103983764786172}
                                                width={9.134719206531479}
                                                height={8.207967529572343}
                                                style={{
                                                      transform:
                                                            "scale(2.7907804238629645)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                        </g>
                        <g transform="translate(0 -435.46336186408894)">
                              <g transform="translate(252.12227801608503 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-1.8048847657627323s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-5.235129825022388}
                                                y={-4.026585017063388}
                                                width={10.470259650044776}
                                                height={8.053170034126776}
                                                style={{
                                                      transform:
                                                            "scale(3.1297517360469627)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1258.3448244045794 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-1.5966347603718685s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-5.743152209341826}
                                                y={-4.14001727880739}
                                                width={11.486304418683652}
                                                height={8.28003455761478}
                                                style={{
                                                      transform:
                                                            "scale(1.966943666897683)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(838.364515292295 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-0.5755094982732336s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-3.92036839636315}
                                                y={-3.253722243825411}
                                                width={7.8407367927263}
                                                height={6.507444487650822}
                                                style={{
                                                      transform:
                                                            "scale(1.903626062460912)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1015.105708187234 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-0.7858345683472883s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-3.00806361499066}
                                                y={-4.415393764172474}
                                                width={6.01612722998132}
                                                height={8.830787528344947}
                                                style={{
                                                      transform:
                                                            "scale(2.2112911078009283)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1060.45111566171 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-3.0735867081755064s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-4.2424142475035485}
                                                y={-3.8647325906668284}
                                                width={8.484828495007097}
                                                height={7.729465181333657}
                                                style={{
                                                      transform:
                                                            "scale(3.4160492034266587)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1373.0199622557418 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-0.532368018314151s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-5.317705279152215}
                                                y={-4.695351610513324}
                                                width={10.63541055830443}
                                                height={9.390703221026648}
                                                style={{
                                                      transform:
                                                            "scale(1.6016231406732697)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1472.0101143125955 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-0.5399583963147014s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-5.643852761068592}
                                                y={-3.6685635490735997}
                                                width={11.287705522137184}
                                                height={7.337127098147199}
                                                style={{
                                                      transform:
                                                            "scale(2.5502843095803978)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1425.0652944873948 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-2.337849567994355s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-4.24630905925182}
                                                y={-5.7682884054520995}
                                                width={8.49261811850364}
                                                height={11.536576810904199}
                                                style={{
                                                      transform:
                                                            "scale(2.820631309798371)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(376.1028868134674 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-0.6321681512536546s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-4.300837667326902}
                                                y={-5.136110152907795}
                                                width={8.601675334653804}
                                                height={10.27222030581559}
                                                style={{
                                                      transform:
                                                            "scale(2.280587131750873)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1434.2938926926429 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-0.2428908212335772s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-3.454418954350106}
                                                y={-5.483404792092944}
                                                width={6.908837908700212}
                                                height={10.966809584185889}
                                                style={{
                                                      transform:
                                                            "scale(2.517065874313353)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(705.5726343039071 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-0.38706294322669343s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-4.665399952457015}
                                                y={-3.1946403688573155}
                                                width={9.33079990491403}
                                                height={6.389280737714631}
                                                style={{
                                                      transform:
                                                            "scale(2.2088639179512275)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(829.31785731886 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-0.9478907555685998s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-3.8206512138508923}
                                                y={-5.987615775511404}
                                                width={7.641302427701785}
                                                height={11.975231551022809}
                                                style={{
                                                      transform:
                                                            "scale(1.6131896288523453)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(824.1357551944989 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-1.238286012810513s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-4.1249450838428965}
                                                y={-4.095214800651716}
                                                width={8.249890167685793}
                                                height={8.190429601303432}
                                                style={{
                                                      transform:
                                                            "scale(1.922637988415215)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(738.1472922363736 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-3.3586830861603127s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-4.618067505077739}
                                                y={-5.689251093797545}
                                                width={9.236135010155477}
                                                height={11.37850218759509}
                                                style={{
                                                      transform:
                                                            "scale(2.6814541745169866)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(671.0494979538338 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-2.4443364994173784s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-5.579422461655465}
                                                y={-4.623248299549779}
                                                width={11.15884492331093}
                                                height={9.246496599099558}
                                                style={{
                                                      transform:
                                                            "scale(1.9099722829483055)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(34.68714404880325 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-1.165443733720314s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-3.8923959257898773}
                                                y={-5.957351342410082}
                                                width={7.7847918515797545}
                                                height={11.914702684820163}
                                                style={{
                                                      transform:
                                                            "scale(2.5700231125088155)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1210.1792984468862 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-0.09990602201506249s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-5.975072580789338}
                                                y={-5.857028882435017}
                                                width={11.950145161578677}
                                                height={11.714057764870034}
                                                style={{
                                                      transform:
                                                            "scale(2.9838935620062172)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(74.2272980749924 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-0.6238835618869936s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-4.170140999141763}
                                                y={-5.555002466097458}
                                                width={8.340281998283526}
                                                height={11.110004932194917}
                                                style={{
                                                      transform:
                                                            "scale(2.3484401304924183)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(24.450260667057364 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-1.0980882211384566s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-4.765488936738785}
                                                y={-3.712392812355025}
                                                width={9.53097787347757}
                                                height={7.42478562471005}
                                                style={{
                                                      transform:
                                                            "scale(2.4584834135676554)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1048.7710148638516 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-0.7767305253632597s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-3.1908039548001046}
                                                y={-3.1138407167145714}
                                                width={6.381607909600209}
                                                height={6.227681433429143}
                                                style={{
                                                      transform:
                                                            "scale(2.6031941369136247)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1420.8607191709311 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-0.22957772163329349s",
                                                animationDuration: "5s",
                                          }}
                                    >
                                          <rect
                                                x={-5.5045823033226915}
                                                y={-5.709917617429362}
                                                width={11.009164606645383}
                                                height={11.419835234858724}
                                                style={{
                                                      transform:
                                                            "scale(3.3402876491052225)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(816.1786468437467 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-2.190024442414451s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-3.5472473805333338}
                                                y={-3.4316080245859735}
                                                width={7.0944947610666675}
                                                height={6.863216049171947}
                                                style={{
                                                      transform:
                                                            "scale(1.7898834193936364)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1220.2570452900377 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-0.6588188521807083s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-3.5860250352656102}
                                                y={-5.031441210145333}
                                                width={7.1720500705312205}
                                                height={10.062882420290666}
                                                style={{
                                                      transform:
                                                            "scale(2.8126667061490416)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(1020.1962290747173 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-3.839379413881523s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-4.603432080026506}
                                                y={-3.218349405299614}
                                                width={9.206864160053012}
                                                height={6.436698810599228}
                                                style={{
                                                      transform:
                                                            "scale(2.0148911136997034)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                              <g transform="translate(787.9682766179483 0)">
                                    <g
                                          className="ld ld-fall"
                                          style={{
                                                animationDelay:
                                                      "-1.548292379036611s",
                                                animationDuration: "10s",
                                          }}
                                    >
                                          <rect
                                                x={-4.567359603265739}
                                                y={-4.103983764786172}
                                                width={9.134719206531479}
                                                height={8.207967529572343}
                                                style={{
                                                      transform:
                                                            "scale(2.7907804238629645)",
                                                }}
                                                fill={svgThemes[theme]}
                                          />
                                    </g>
                              </g>
                        </g>
                  </g>
            </svg>
      );
};
